import React, { useState } from 'react';
import { Alert, AlertProps } from 'antd';
import { InfoCircleOutlined, CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';

import constants from '../config/constants';

type BannerType = 'info' | 'success' | 'warning' | 'error';

const MAP_ICONS: Record<BannerType, React.ReactNode> = {
    info: <InfoCircleOutlined />,
    success: <CheckCircleOutlined />,
    warning: <WarningOutlined />,
    error: <CloseCircleOutlined />,
};

interface InfoBannerProps {
    type?: BannerType;
    message: React.ReactNode;
    description?: React.ReactNode;
    isDismissible?: boolean;
    onClose?: AlertProps['onClose'];
    actionButton?: React.ReactNode;
}

export default function InfoBanner({
    type = constants.MESSAGE_INFO_TYPE as BannerType,
    message,
    description,
    isDismissible = true,
    onClose,
    actionButton,
}: InfoBannerProps): JSX.Element | null {
    const [visible, setVisible] = useState<boolean>(true);

    if (!visible) return null;

    const handleClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setVisible(false);
        if (onClose) onClose(e);
    };

    const centeredMessage = (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '16px' }}>{MAP_ICONS[type]}</span>
            <span>{message}</span>
        </div>
    );

    return (
        <div style={{ width: '100%' }}>
            <Alert
                message={centeredMessage}
                description={
                    typeof description === 'string' ? (
                        <span style={{ color: '#1890ff' }}>{description}</span>
                    ) : (
                        description
                    )
                }
                type={type}
                showIcon={false}
                icon={MAP_ICONS[type]}
                closable={isDismissible}
                onClose={handleClose}
                action={actionButton}
                style={{
                    borderRadius: 0,
                    padding: '12px 24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            />
        </div>
    );
}
